import { SxProps, Theme } from '@mui/material/styles';

export enum FIELD_TYPES {
  BUTTON = 'BUTTON',
  TEXT = 'TEXT',
  RICH_TEXT = 'RICH_TEXT',
  RICH_TEXT_HTML = 'RICH_TEXT_HTML',
  URL = 'URL',
  NUMBER = 'NUMBER',
  IMAGE = 'IMAGE',
  SWITCH = 'SWITCH',
  SELECT = 'SELECT',
  MULTI_SELECT = 'MULTI_SELECT',
  COLOR_PICKER = 'COLOR_PICKER',
  SCENE_CONFIG = 'SCENE_CONFIG',
  INFO_FIELDS = 'INFO_FIELDS',
  PUSH_NOTIFICATION_IMAGE = 'PUSH_NOTIFICATION_IMAGE',
  DATE = 'DATE',
  DATETIME = 'DATETIME',
  PROMO_FIELD = 'PROMO_FIELD',
  PROMO_SELECT = 'PROMO_SELECT',
  PROMO_SELECT_MULTIPLE = 'PROMO_SELECT_MULTIPLE',
  PROMO_TIMED = 'PROMO_TIMED',
  VALIDATE_RSS = 'VALIDATE_RSS',
}

export interface UIschema {
  name: string;
  title?: string;
  superAdminOnly?: boolean;
  fields: Field[] | InfoField[];
  isTeamDataValue?: boolean;
}

export interface Field {
  title: string;
  type: string;
  id: string;
  value: string | string[] | number | boolean | null | undefined;
  key: string;
  validation?: any;
  options?: any[];
  optionsText?: string[];
  optionsFilter?: string;
  isReadOnly?: boolean;
  superAdminOnly?: boolean;
  isTeamDataValue?: boolean;
  fields?: Field[];
  numRows?: number;
  helperText?: string;
}

export interface InfoField {
  type: string;
  id: string;
  fields?: Field[];
}

export type Option = string | number | boolean;

export interface OptionsGroup {
  name: string;
  options: Option[];
  optionsText?: string[] | null;
}

export enum ROLES {
  ADMIN = 'admin',
  EDITOR = 'editor',
  VIEWER = 'viewer',
  NONE = '',
}

export enum APP_TYPE {
  CLUB = 'club',
  LEAGUE = 'league',
}

export type TeamRoles = ROLES.ADMIN | ROLES.EDITOR | ROLES.VIEWER | ROLES.NONE;

export type TeamPermissions = Record<string, TeamRoles>;

export type SuperAdminUser = {
  email: string;
  superadmin: boolean;
  teams: TeamPermissions;
  uid: string;
};

export enum SUPPORTED_LEAGUES {
  ALLSVENSKAN = 'allsvenskan',
  DAMALLSVENSKAN = 'damallsvenskan',
  SUPERETTAN = 'superettan',
  ELITETTAN = 'elitettan',
  FUTSAL = 'futsal',
}

export type ConfigLeagueNameOptions =
  | SUPPORTED_LEAGUES.ALLSVENSKAN
  | SUPPORTED_LEAGUES.DAMALLSVENSKAN
  | SUPPORTED_LEAGUES.SUPERETTAN
  | SUPPORTED_LEAGUES.ELITETTAN
  | SUPPORTED_LEAGUES.FUTSAL;

export type SxStyle = Record<string, SxProps<Theme>>;
